import { render, staticRenderFns } from "./RightsFundLogCopy.vue?vue&type=template&id=699884fa"
import script from "./RightsFundLogCopy.vue?vue&type=script&lang=js"
export * from "./RightsFundLogCopy.vue?vue&type=script&lang=js"
import style0 from "./RightsFundLogCopy.vue?vue&type=style&index=0&id=699884fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports